
import { Component, Emit, Prop, Watch } from 'vue-property-decorator'
import Abpbase from '@/lib/abpbase'
import RightPanel from '@/components/right-panel/index.vue'
import Dolist from '@/entities/dolist'
import CommonTable from '@/components/common-table/index.vue'
import { ElTable } from 'element-ui/types/table'
import DoDetail from '@/entities/dodetail'
import dictAction from '@/mixins/dict-action'
import util from '@/lib/util'

@Component({
  components: {
    RightPanel,
    CommonTable
  },
  mixins: [dictAction]
})
export default class DolistPanel extends Abpbase {
  name: 'EmptotePanel'

  dictEpodDoMaster = 'epod_do_master'
  dictEpodDoDetail = 'epod_do_detail'

  @Prop({
    type: Object,
    default: () => {}
  })
  item: Dolist

  info: Dolist = new Dolist()

  loading: boolean = false

  get composeFromAddress() {
    if (
      this.info.shipFromPostcode &&
      this.info.shipFromCity &&
      this.info.shipFromCountry
    ) {
      return `${this.info.shipFromPostcode} ${this.info.shipFromCity} ${this.info.shipFromCountry}`
    } else if (
      !this.info.shipFromPostcode &&
      !this.info.shipFromCity &&
      !this.info.shipFromCountry
    ) {
      return '--'
    }
    return `${this.info.shipFromPostcode || ''} ${this.info.shipFromCity ||
      ''} ${this.info.shipFromCountry || ''}`
  }

  get composeToAddress() {
    if (
      this.info.shipToPostcode &&
      this.info.shipToCity &&
      this.info.shipToCountry
    ) {
      return `${this.info.shipToPostcode} ${this.info.shipToCity} ${this.info.shipToCountry}`
    } else if (
      !this.info.shipToPostcode &&
      !this.info.shipToCity &&
      !this.info.shipToCountry
    ) {
      return '--'
    }
    return `${this.info.shipToPostcode || ''} ${this.info.shipToCity ||
      ''} ${this.info.shipToCountry || ''}`
  }

  tableDataList = []

  getTableRef(): ElTable {
    return this.$refs.detailTable as ElTable
  }

  table = this.$standardTableData({
    showPagination: false,
    height: null,
    columns: [
      {
        title: this.L('No.'),
        key: 'index',
        render: (h: any, ctx: any) => {
          return h('span', this.getTableRef().$scopedSlots.no(ctx))
        }
      },
      {
        title: this.L('Trace Id'),
        key: 'traceId'
      }
    ]
  })

  @Emit('close')
  doExpandClose() {}

  @Watch('item', { deep: true, immediate: true })
  onItemChanged() {
    this.getDetailById()
  }

  /**
   * 通过id获得详情
   */
  async getDetailById() {
    if (!this.item || !this.item.id) {
      this.$message.warning('Data Exception')
      return
    }
    try {
      this.loading = true
      let res = await this.$store.dispatch({
        type: 'emptote/getDetailById',
        id: this.item.id
      })
      this.info = res || {}
      this.tableDataList = this.info.doDetails || []
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  async doShowMap() {
    let res = await this.$store.dispatch({
      type: 'dolist/getTruckLocationByVehicleNo',
      data: this.info.vehicleNo
    })
    if (!res) {
      this.$message.warning('No results found')
      return
    }
    let url = `https://www.google.com/maps/search/?api=1&query=${res.latitude}%2C${res.longitude}`
    util.openLink(url)
  }
}
